export default function Logo() {
  return (
    <h1 id="logo">
      <div className={`logo-content`}>
        <img
          className={`logo-desktop`}
          src="/assets/images/sagebrush-logo.png"
          alt="Sagebrush Wealth FZE"
          width={140}
          height={160}
          style={{ objectFit: 'contain' }}
        />
        <img
          className={`logo-tablet`}
          src="/assets/images/sagebrush-logo.png"
          alt="Sagebrush Wealth FZE"
          width={45}
          height={52}
          style={{ objectFit: 'contain' }}
        />
      </div>
    </h1>
  )
}
